import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiBarChart } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const CaseTracking = () => {
  const { t } = useTranslation();

  const description = t("service_pages.case_tracking.description");
  const features = t("service_pages.case_tracking.features", { returnObjects: true });
  const highlights = t("service_pages.case_tracking.highlights", { returnObjects: true });
  const steps = t("service_pages.case_tracking.steps", { returnObjects: true });
  const faqs = t("service_pages.case_tracking.faqs", { returnObjects: true });

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Immigration Case Tracking",
    description,
    provider: {
      "@type": "LocalBusiness",
      name: "Citizen Hub Immigration Services",
      telephone: "+1 3108802133",
      email: "info@citznhub.com",
    },
    areaServed: ["United States", "California", "New York", "Texas", "Florida"],
  };

  // Create a simple icon-based image placeholder
  const IconPlaceholder = () => (
    <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl shadow-lg flex items-center justify-center">
      <FiBarChart className="w-48 h-48 text-white opacity-80" />
    </div>
  );

  return (
    <ServiceDetailLayout
      title={t("service_pages.case_tracking.title")}
      subtitle={t("service_pages.case_tracking.subtitle")}
      description={description}
      features={features}
      highlights={highlights}
      steps={steps}
      faqs={faqs}
      imageSrc={null}
      imageAlt="Immigration case tracking"
      canonicalUrl="https://citizenhubimmigration.com/services/case-tracking"
      structuredData={structuredData}
      customImage={<IconPlaceholder />}
    />
  );
};

export default CaseTracking;
